module.exports = __webpack_public_path__ + "static/15-aa7cd00220ffeabae7f923c5b7e9ffc9.png";